/* global navigation */

/**
 * Arrow left element associated with the go back a page browser action.
 */
const checkoutHeader = {};

// Constants
const SELECTOR = '.hom-checkout-header';

/**
 * Attach a go back redirection on the checkout header
 * Attach the event listener once to avoid multiple go backs
 */
checkoutHeader.addEventListener = function () {
    $(SELECTOR).one('click', function (e) {
        e.preventDefault();
        var link = $(this).attr('href'); // Get link inside the "href"
        if (typeof link !== undefined) {
            window.location.replace( // Go to URL
                link,
              );
        }
    });
};

module.exports = checkoutHeader;
